import counties from '@/utils/state-counties.json'

// Geocoders (Azure Maps, FCC) return county names in spellings that don't always
// match our canonical state-counties.json — e.g. "Saint Clair County" vs "St. Clair",
// "De Kalb County" vs "DeKalb". Fold both sides to a comparison key so a geocoded
// county can be mapped back to the exact name the County dropdown uses.
const normalizeCountyName = (name) => {
  if (!name) return ''
  return String(name)
    .toLowerCase()
    // Drop administrative suffixes the geocoders append. Note: "city" is intentionally
    // NOT stripped — Virginia/Maryland independent cities (e.g. "Baltimore City" vs
    // "Baltimore") are distinct entries in the list.
    .replace(/\b(county|parish|borough|census area|municipality)\b/g, '')
    // Fold the Saint/Sainte/Ste. family to a single form so "Saint Clair" === "St. Clair".
    .replace(/\bsainte\b/g, 'st')
    .replace(/\bsaint\b/g, 'st')
    .replace(/\bste\b/g, 'st')
    // Strip punctuation and spacing so "St. Clair" === "stclair" and "De Kalb" === "dekalb".
    .replace(/[^a-z0-9]/g, '')
}

// Returns the canonical county name (matching state-counties.json) for a raw geocoder
// result, or null if it can't be reconciled with our list for that state.
export const canonicalCountyName = (stateCode, rawCountyName) => {
  const stateCounties = counties[stateCode]
  if (!stateCounties || !rawCountyName) return null
  const target = normalizeCountyName(rawCountyName)
  if (!target) return null
  const match = stateCounties.find(c => normalizeCountyName(c.N) === target)
  return match ? match.N : null
}
